module.exports = __webpack_public_path__ + "static/media/video-placeholder.5eb6304b.png";